import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { getTheme } from "../../Theme.js";
const theme = getTheme();

const Main = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px;
`;

const Tittle = styled.h1`
  font-size: 4em;
  color: ${theme.MAIN_COLOR};
  text-align: center;
`;

const FloatingBackButton = styled.button`
  position: fixed;
  top: 20px;
  left: 20px;
  background-color: ${theme.MAIN_COLOR};
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
`;

const TermsAndConditions = () => {
  const history = useHistory();
  return (
    <Main>
      <Tittle>TCS Terms and Conditions</Tittle>
      <h1>TERMS AND CONDITIONS</h1>
      <FloatingBackButton onClick={() => history.replace("/")}>
        Back to Home
      </FloatingBackButton>
      <p>
        U.S. Terms and Conditions of Sale – Direct (Applies to all direct
        purchases-by internet, phone, or in our Stores) PLEASE READ THIS
        DOCUMENT CAREFULLY! IT CONTAINS VERY IMPORTANT INFORMATION ABOUT YOUR
        RIGHTS AND OBLIGATIONS, AS WELL AS LIMITATIONS AND EXCLUSIONS THAT MAY
        APPLY TO YOU. THIS DOCUMENT CONTAINS A DISPUTE RESOLUTION CLAUSE. These
        Terms are between Timecard Solutions LLC (“timecardsolutions.com”,
        "TCS", “us”, “we” or “our”) and you, either individually, or on behalf
        of your employer or other entities which you represent (“you” or
        “your”). By using our software you accept and are bound to the terms and
        conditions of this Agreement. IF YOU DO NOT AGREE TO COMPLY WITH, AND BE
        BOUND BY, THESE TERMS OR DO NOT HAVE AUTHORITY TO BIND YOUR EMPLOYER OR
        ANY OTHER ENTITY (AS APPLICABLE), PLEASE DO NOT ACCEPT THESE TERMS, OR
        ACCESS OR USE THE SERVICES OR THE SITES OR timecardsolutions.com MOBILE
        APPLICATION.
      </p>
      <h3>TCS Application</h3>
      <h4>1. Services</h4>
      <u>1.1 Our Sevices</u>
      <p>
        Services offered by TCS include all platforms (web, mobile, etc.),
        integrations, products and services offered online and via our mobile
        applications.
      </p>
      <u>1.2 Modification or Cancelation of services</u>
      <p>
        We may add, modify or discontinue any feature, functionality or any
        other tool within any Services and/or Sites, at our own discretion and
        without further notice, however, if we make any material adverse change
        in the core functionality of the Services, then we will notify you by
        posting an announcement on the Sites, via the Services and/or by sending
        you an email.
      </p>
      <u>1.3 No Contingency on Future updates and improvments</u>
      <p>
        You hereby acknowledge that your purchase of the Services and/or Third
        Party Services (as defined below) hereunder are not contingent on the
        delivery by us of any future updates, feature or service, including
        without limitation: (i) the continuance of certain Services or
        Additional Services (as defined below) beyond the current Subscription
        Term; (ii) the availability of Third Party Services, or (iii) dependency
        on any public comments we make, orally or in writing, regarding any
        future functionality, feature or service.
      </p>
      <u>1.4 Technical Support and Committed Uptime.</u>
      <p>
        If you access and use the Sites and/or the Services, you represent and
        warrant that you are at least sixteen (16) years old. The Sites and/or
        Services are only intended for individuals aged sixteen (16) years or
        older. We reserve the right to request proof of age at any stage so that
        we can verify compliance with this paragraph.
      </p>

      <u>1.5 Technical Support and Committed Uptime.</u>
      <p>
        To the extent you purchased an eligible enterprise tier subscription,
        you will be entitled, in relation to the Services, to priority support
        and an uptime commitment by TCS, in accordance with the Service Level
        Agreement, as may be updated from time to time.
      </p>

      <h3>TCS Mobile Messaging Service</h3>
      <h4>1. Description</h4>
      <p>
        TCS Mobile messaging service is a sms based service allowing you to
        request information about your account, use features of the application
        via commands, receive important updates from your employer and receive
        important updates about your account as well as 2fa codes for account
        access and verification
      </p>
      <h4>2. Opt-out instructions</h4>
      <p>
        You can cancel the SMS service at any time. Just text <b>STOP</b> to the
        short code. After you send the SMS message <b>STOP</b> to us, we will
        send you an SMS message to confirm that you have been unsubscribed.
        After this, you will no longer receive SMS messages from us.
      </p>
      <h4>3. Support</h4>
      <p>
        If you are experiencing issues with the messaging program you can reply
        with the keyword <b>HELP</b> for more assistance, or you can get help
        directly at{" "}
        <a href="mailto:support@timecardsolutions.com">
          support@timecardsolutions.com
        </a>
        .
      </p>
      <h4>4. Disclosure</h4>
      <p>Carriers are not liable for delayed or undelivered messages</p>
      <h4>5. Messaging Rates</h4>
      <p>
        As always, message and data rates may apply for any messages sent to you
        from us and to us from you. You will receive messages whenever logging
        in, using sms based services or recieving notifications about your
        account on average 1-10 messages per day. If you have any questions
        about your text plan or data plan, it is best to contact your wireless
        provider.
      </p>
      <p>
        If you have any questions regarding privacy, please read our privacy
        policy:{" "}
        <a href="timecardsolutions.com/privacy">
          timecardsolutions.com/privacy
        </a>
      </p>
    </Main>
  );
};
export default TermsAndConditions;
